module.exports = __webpack_public_path__ + "img/profiling-question-scheme.981e0cec.png";